import { useEffect, useState } from 'react';
import '../App.scss';
import { Button } from '@mui/base/Button';
import { TextField, FormControlLabel, Switch, } from '@mui/material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import { AdminClient, CompanyModel } from '../types';
import { createClient } from "../api/clients";

function CreateCompany() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [name, setName] = useState('');
const [projectLimit, setProjectLimit] = useState<number | ''>('');
  const [isEnabled, setIsEnabled] = useState(true);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const adminClient = createClient(AdminClient);

  useEffect(() => {
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage(null);

   
    const company: CompanyModel = { name, isEnabled, projectLimit: Number(projectLimit)};

    try {
      const result = await adminClient.createCompany(company);

      if (result.success === false) {
        setErrorMessage(result.error ?? null);
        return;
      }

     navigate(`/admin`, { replace: true });
    } catch (error) {
      console.error('Error creating company:', error);
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="main pb-4 d-flex flex-column align-items-center">
      <Button
        className="styled-button mb-4"
        onClick={() => navigate('/admin')}
      >
        ← Back
      </Button>

      <h4 className="mb-6">Create Company</h4>

      <form onSubmit={handleSubmit} className="d-flex flex-column align-items-center">
        <TextField
          id="name"
          label="Name"
          variant="outlined"
          className="mb-4"
          style={{ minWidth: '300px' }}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <TextField
          id="projectLimit"
          label="Project Limit"
          variant="outlined"
          type="number"
          className="mb-4"
          style={{ minWidth: '300px' }}
          value={projectLimit}
          onChange={(e) => {
            const value = e.target.value;
            setProjectLimit(value === '' ? '' : Number(value));
          }}
          required
/>
        <FormControlLabel
          control={
            <Switch
              checked={isEnabled}
              onChange={(e) => setIsEnabled(e.target.checked)}
              color="primary"
            />
          }
          label="Enabled"
          className="mb-4"
        />
        {errorMessage && (
          <div className="form-error mb-3">
            {errorMessage}
          </div>
        )}

        <Button type="submit" className="styled-button mb-4" id="btn-create-company">
          Create company
        </Button>
      </form>
    </div>
  );
}

export default CreateCompany;
